import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import { cardHeaderStyles, cardContentStyles } from "../../../theme/mixins";

export const PlacedCandidatesWrapper = styled.div`
  margin: 50px 0;
`;

export const Header = styled.div`
  ${cardHeaderStyles};
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.white};
`;

export const Content = styled.div`
  ${cardContentStyles};
  justify-content: space-between;
  width: 75%;

  ${mediaMaxWidth.tablet} {
    width: 100%;
  }
`;

export const HeaderItem = styled.div`
  flex: 1;
`;

export const ContentItem = styled.div`
  font-size: ${({ theme }) => theme.fontSize.small.desktop};
  text-transform: capitalize;

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.small.mobile};
  }
`;

interface IDotProps {
  item?: string;
}

export const Dot = styled.span`
  width: 12px;
  height: 12px;
  background: ${(props: IDotProps) =>
    props.item === "placed" ? "#fff" : null};
  background: ${(props: IDotProps) =>
    props.item === "interviewed" ? "#79D9D9" : null};
  background: ${(props: IDotProps) =>
    props.item === "submitted" ? "rgba(255, 255, 255, 0.3)" : null};
  display: inline-block;
  border-radius: 50%;
  margin-right: 12px;
  position: relative;
  top: 1px;
`;

export const Candidates = styled.div`
  display: block;
  margin: 20px 0;
  padding: 0 5px;

  .candidate-icon {
    font-size: 2.1em;

    ${mediaMaxWidth.tablet} {
      font-size: 1.7em;
    }
  }

  .placed {
    color: ${({ theme }) => theme.colors.white};
  }

  .interviewed {
    color: ${({ theme }) => theme.colors.primary};
  }

  .submitted {
    color: rgba(255, 255, 255, 0.3);
  }
`;

export const Icon = styled.i`
  color: ${({ theme }) => theme.colors.red};
`;

export const NoData = styled.span`
  font-size: ${({ theme }) => theme.fontSize.large.desktop};
  padding: 0 5px;

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.large.mobile};
  }
`;
